import BaseService from "./BaseService";

export interface IOrgHomeDashboardConfiguration {
    key: string;
    value?: string | null;
}

export class OrgConfigurationService extends BaseService {
    protected urlBase: string = "api/Organizations";

    public async getOrgConfiguration(key: string) {
        const params = new URLSearchParams({});
        const res = await this.get(params, "Configurations");
        return res;
    }

    public async getOrgHomeDashboardConfiguration(): Promise<
        IOrgHomeDashboardConfiguration
    > {
        const params = new URLSearchParams({});
        const res = await this.get<IOrgHomeDashboardConfiguration>(
            params,
            "HomeDashboardConfiguration",
        );
        return res;
    }

    public async updateOrgConfiguration(key: string, value: string) {
        const params = new URLSearchParams({});
        const res = await this.put(
            params,
            "Configurations",
            JSON.stringify({ "OrganizationConfigurations": { [key]: value } }),
        );
        return res;
    }
    public async deleteOrgConfiguration(key: string, value: string) {
        const params = new URLSearchParams({});
        const res = await this.delete(
            params,
            "Configurations",
            JSON.stringify({ "OrganizationConfigurations": { [key]: value } }),
        );
        return res;
    }
}
